// extracted by mini-css-extract-plugin
export default {"about_page":"AboutPage_about_page__rWNrv","schedule_section":"AboutPage_schedule_section__XrSaf","headingx":"AboutPage_headingx__8QdaM"};